// Define fixed colors for preset configurations - consistent across all views
// Following SOLID principles: Single Responsibility - manages only preset colors
export const PRESET_COLORS = [
  { bg: '#e6f3ff', border: '#b3d9ff', text: '#2c3e50', name: 'Light Blue' },
  { bg: '#fff2e6', border: '#ffcc99', text: '#2c3e50', name: 'Light Orange' },
  { bg: '#f0f8e6', border: '#d4e6c1', text: '#2c3e50', name: 'Light Green' },
  { bg: '#ffe6f0', border: '#ffb3d1', text: '#2c3e50', name: 'Light Pink' },
  { bg: '#f3e6ff', border: '#e0b3ff', text: '#2c3e50', name: 'Light Purple' },
  { bg: '#e6fff9', border: '#b3ffec', text: '#2c3e50', name: 'Light Mint' },
  { bg: '#fffde6', border: '#fff9b3', text: '#2c3e50', name: 'Light Yellow' },
  { bg: '#ffe6e6', border: '#ffb3b3', text: '#2c3e50', name: 'Light Red' },
];

/**
 * Get consistent color for preset based on its index in the testgroup
 * @param {Object} testGroup - The test group object
 * @param {string|number} presetId - The preset ID
 * @returns {Object|null} Color configuration object or null
 */
export const getPresetColor = (testGroup, presetId) => {
  if (!testGroup?.advancedSetting?.preSettings) return null;

  const presetIndex = testGroup?.advancedSetting?.preSettings?.findIndex(
    (preset) => String(preset.id) === String(presetId)
  );

  if (presetIndex === -1) return null;

  return PRESET_COLORS[presetIndex % PRESET_COLORS.length];
};

/**
 * Get preset style object ready for React inline styles
 * @param {Object} testGroup - The test group object
 * @param {string|number} presetId - The preset ID
 * @returns {Object} Style object for React components
 */
export const getPresetStyle = (testGroup, presetId) => {
  const colorConfig = getPresetColor(testGroup, presetId);

  if (!colorConfig) return {};

  return {
    backgroundColor: colorConfig.bg,
    border: `2px solid ${colorConfig.border}`,
    borderRadius: '8px',
  };
};

/**
 * Get preset text color class for elements with preset background
 * @param {Object} testGroup - The test group object
 * @param {string|number} presetId - The preset ID
 * @returns {string} CSS class name for text color
 */
export const getPresetTextColorClass = (testGroup, presetId) => {
  const colorConfig = getPresetColor(testGroup, presetId);
  return colorConfig ? 'text-dark' : '';
};
